// extracted by mini-css-extract-plugin
module.exports = {"QuoteFull3":"QuoteFull3_QuoteFull3__5q4wK","authorImg":"QuoteFull3_authorImg__RJA8l"};